import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

interface OrganizationBackLinkProps {
	placement?: "inline" | "action";
}

export function OrganizationBackLink({ placement = "inline" }: OrganizationBackLinkProps) {
	const navigate = useNavigate();

	return (
		<Button
			className={`crm-back-link ${placement === "action" ? "action" : ""}`}
			icon={<ArrowLeftOutlined />}
			onClick={() => navigate(-1)}
		>
			Tashkilotlar
		</Button>
	);
}
